<div class="mt-4">
    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        {{title}}
                    </mat-panel-title>

                    <mat-panel-description *ngIf="showStatus" class="">
                        <sway-baseline-status *ngIf="baselineLinkedToPolicy" [hasError]="hasErrors"></sway-baseline-status>


                        <mat-icon *ngIf="!baselineLinkedToPolicy" >
                            <mat-icon class="warn-icon"
                                matTooltip="Baseline is not associated with any policy">warning</mat-icon>
                        </mat-icon>
                    </mat-panel-description>

                </div>

            </mat-expansion-panel-header>

            <div>
                <mat-error *ngIf="hasErrors">
                    {{errorsString}}
                </mat-error>

                <ng-content></ng-content>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>